var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "oc-settings__sub-header" }, [_vm._v("Email:")]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Email отправителя:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.settings.mail_from.email,
              expression: "settings.mail_from.email",
              modifiers: { trim: true }
            }
          ],
          staticClass: "oc-form__control",
          attrs: {
            type: "email",
            name: "settings[mail_from][email]",
            placeholder: "noreply@email"
          },
          domProps: { value: _vm.settings.mail_from.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.settings.mail_from,
                "email",
                $event.target.value.trim()
              )
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Получатели:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("table", { staticClass: "table sort ui-sortable oc-sort" }, [
          _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  staticClass: "oc-settings__add-row",
                  attrs: { colspan: "6" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "oc-settings-btn",
                      on: {
                        click: function($event) {
                          return _vm.addItem(_vm.settings.mail_to, {
                            active: 1,
                            value: "",
                            store: ["general"]
                          })
                        }
                      }
                    },
                    [_vm._v("Добавить получателя")]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.settings.mail_to, function(mail, index) {
              return _c(
                "tr",
                { key: index, staticStyle: { opacity: "1", "z-index": "0" } },
                [
                  _c(
                    "td",
                    { staticClass: "oc-col_min-width oc-settings__check-col" },
                    [
                      _c(
                        "span",
                        { staticClass: "hint" },
                        [
                          _c("checkbox", {
                            attrs: {
                              checked: !!+_vm.settings.mail_to[index].active
                            },
                            on: {
                              change: function(val) {
                                _vm.settings.mail_to[index].active = +val
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.settings.mail_to[index].value,
                          expression: "settings.mail_to[index].value",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "input mail-input",
                      attrs: {
                        type: "text",
                        name: "settings[mail_to][" + index + "][value]",
                        placeholder:
                          "mail@site.ru, support@site.ru, info@site.ru",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.settings.mail_to[index].value },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.settings.mail_to[index],
                            "value",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "oc-settings__storefront-col" },
                    [
                      _c("dropdown-store", {
                        attrs: {
                          domains: _vm.domains,
                          store: _vm.settings.mail_to[index].store
                        },
                        on: {
                          change: function(val) {
                            _vm.settings.mail_to[index].store = val
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "oc-col_min-width" }, [
                    _vm.settings.mail_to.length > 1
                      ? _c(
                          "span",
                          {
                            staticClass: "oc-clickable",
                            on: {
                              click: function($event) {
                                return _vm.deleteItem(
                                  _vm.settings.mail_to,
                                  index
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "oc-icon16 ico-delete" })]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Тема письма:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.settings.mail_subject,
              expression: "settings.mail_subject",
              modifiers: { trim: true }
            }
          ],
          staticClass: "oc-form__control",
          attrs: {
            type: "text",
            name: "settings[mail_subject]",
            placeholder: "Заказ обратного звонка №[id] с сайта [site_name]"
          },
          domProps: { value: _vm.settings.mail_subject },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.settings, "mail_subject", $event.target.value.trim())
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Шаблон письма:")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-4" },
        [
          _c("redactor", {
            model: {
              value: _vm.settings.mail_body,
              callback: function($$v) {
                _vm.$set(_vm.settings, "mail_body", $$v)
              },
              expression: "settings.mail_body"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-4" },
        [_c("hot-var", { attrs: { settings: _vm.settings } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("h2", { staticClass: "oc-settings__sub-header" }, [_vm._v("SMS:")]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Получатели:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("table", { staticClass: "table sort ui-sortable oc-sort" }, [
          _c("tfoot", [
            _c("tr", [
              _c(
                "td",
                {
                  staticClass: "oc-settings__add-row",
                  attrs: { colspan: "6" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "oc-settings-btn",
                      on: {
                        click: function($event) {
                          return _vm.addItem(_vm.settings.sms_to, {
                            active: 1,
                            value: "",
                            store: ["general"]
                          })
                        }
                      }
                    },
                    [_vm._v("Добавить получателя")]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.settings.sms_to, function(sms, index) {
              return _c(
                "tr",
                { key: index, staticStyle: { opacity: "1", "z-index": "0" } },
                [
                  _c(
                    "td",
                    { staticClass: "oc-col_min-width oc-settings__check-col" },
                    [
                      _c(
                        "span",
                        { staticClass: "hint" },
                        [
                          _c("checkbox", {
                            attrs: {
                              checked: !!+_vm.settings.sms_to[index].active
                            },
                            on: {
                              change: function(val) {
                                _vm.settings.sms_to[index].active = +val
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.settings.sms_to[index].value,
                          expression: "settings.sms_to[index].value",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "settings[sms_to][][value]",
                        placeholder: "+791111111111, 89593849525"
                      },
                      domProps: { value: _vm.settings.sms_to[index].value },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.settings.sms_to[index],
                            "value",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "oc-settings__storefront-col" },
                    [
                      _c("dropdown-store", {
                        attrs: {
                          domains: _vm.domains,
                          store: _vm.settings.sms_to[index].store
                        },
                        on: {
                          change: function(val) {
                            _vm.settings.sms_to[index].store = val
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "oc-col_min-width" }, [
                    _vm.settings.sms_to.length > 1
                      ? _c(
                          "span",
                          {
                            staticClass: "oc-clickable",
                            on: {
                              click: function($event) {
                                return _vm.deleteItem(
                                  _vm.settings.sms_to,
                                  index
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "oc-icon16 ico-delete" })]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { staticClass: "col-xs-2 control-label" }, [
        _vm._v("Шаблон письма:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-4" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.settings.sms_text,
              expression: "settings.sms_text",
              modifiers: { trim: true }
            }
          ],
          staticClass: "oc-form__control oc-form__textarea",
          staticStyle: { resize: "none", height: "auto" },
          attrs: { name: "settings[sms_text]", placeholder: "", rows: "11" },
          domProps: { value: _vm.settings.sms_text },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.settings, "sms_text", $event.target.value.trim())
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-4" },
        [_c("hot-var", { attrs: { settings: _vm.settings } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99d065d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99d065d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/notification/Notification.vue
// module id = 147
// module chunks = 0